// extracted by mini-css-extract-plugin
module.exports = {"ZDComp":"ZD_ZDComp__xe_5z"};